import * as React from 'react';
export var AppRegistration = function (props) {
    var width = props.width, alt = props.alt, ariaHidden = props.ariaHidden;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: width || '24px', viewBox: "0 0 24 24", width: width || '24px', fill: "var(--primary-color)", "aria-hidden": ariaHidden },
        React.createElement("title", null, alt),
        React.createElement("g", null,
            React.createElement("rect", { fill: "none", height: "24", width: "24" })),
        React.createElement("g", null,
            React.createElement("rect", { height: "4", width: "4", x: "10", y: "4" }),
            React.createElement("rect", { height: "4", width: "4", x: "4", y: "16" }),
            React.createElement("rect", { height: "4", width: "4", x: "4", y: "10" }),
            React.createElement("rect", { height: "4", width: "4", x: "4", y: "4" }),
            React.createElement("polygon", { points: "14,12.42 14,10 10,10 10,14 12.42,14" }),
            React.createElement("path", { d: "M20.88,11.29l-1.17-1.17c-0.16-0.16-0.42-0.16-0.58,0L18.25,11L20,12.75l0.88-0.88C21.04,11.71,21.04,11.45,20.88,11.29z" }),
            React.createElement("polygon", { points: "11,18.25 11,20 12.75,20 19.42,13.33 17.67,11.58" }),
            React.createElement("rect", { height: "4", width: "4", x: "16", y: "4" }))));
};
